import { createSelector } from 'reselect';
import localeUtils from 'utils/LanguageLocale';

const isShopYourStoreEnabledSelector = createSelector(() => {
    const country = localeUtils.getCurrentCountry();
    const killswitchName = 'isShopYourStoreEnabled' + country;
    const globalKillswitch = Sephora.configurationSettings[killswitchName] === true;
    const isShopYourStoreEnabled = globalKillswitch;

    return isShopYourStoreEnabled;
});

export { isShopYourStoreEnabledSelector };
